module.exports = __webpack_public_path__ + "static/media/video_4.329a8a1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/video_4.mp4
// module id = ngW/
// module chunks = 0